import {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
} from 'vuex';
export default {
	computed: {
		...mapState(['user','appInfo']),
		...mapGetters(['userInfo'])
	},
	methods: {
		...mapMutations(['setUserInfoAsync']),
		...mapActions(['getUserInfo','getAppInfo']),
		
	}
}